import React from 'react';
import { protocolStructure, sampleMeta, sampleTimeline } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-120" data-mp="21naq2g858v3b">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="21mr8j0meo8pt">
        <Eyebrow data-id="element-122" data-mp="25ocgq8nzvyto">Look inside</Eyebrow>
        <SectionTitle data-id="element-123" data-mp="25nb2xwflgy89">
          See how a rehabilitation <Mark data-id="element-124" data-mp="1rx7q1w2lugvh">session is organized</Mark>
        </SectionTitle>

        <article className="mt-8 overflow-hidden rounded-2xl border border-brand/10 bg-white shadow-xl" data-id="element-125" data-mp="1rvwjxplosx17">
          <header className="bg-brand p-5" data-id="element-126" data-mp="1wp8zla8e1tht">
            <p className="text-[10px] font-extrabold uppercase tracking-wider text-accent-light" data-id="element-127" data-mp="1hzjrev1vop81">Example session</p>
            <h3 className="mt-1 text-base font-black uppercase text-white md:text-lg" data-id="element-128" data-mp="1mz66la19ofjh">Example Session — 30 Minutes</h3>
          </header>
          <dl className="grid gap-px bg-brand/10 sm:grid-cols-3" data-id="element-129" data-mp="190g8ps6mibu2">
            {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-130" data-mp="a2o4gqnxg1gv">
                <dt className="text-[10px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-131" data-mp="a1d4l1xlrdv1">{label}</dt>
                <dd className="mt-0.5 text-sm font-bold text-brand-deep" data-id="element-132" data-mp="60t4bphqfu4o">{value}</dd>
              </div>)}
          </dl>
          <div className="border-t border-brand/10 px-5 pt-4" data-id="element-133" data-mp="f1r9ib3wq7ou">
            <p className="text-[11px] font-black uppercase tracking-wider text-brand" data-id="element-134" data-mp="f2al7a2yrzuf">Session activity</p>
            <table className="mt-2 w-full text-left text-sm" data-id="element-135" data-mp="3nhu69lthebye">
              <thead className="sr-only" data-id="element-136" data-mp="3ijix7db0g5h8">
                <tr data-id="element-137" data-mp="3igemry6ycdi4">
                  <th scope="col" data-id="element-138" data-mp="11zq1uumfz3g">Session activity</th>
                  <th scope="col" data-id="element-139" data-mp="13kkzlkulk1u">Time</th>
                </tr>
              </thead>
              <tbody data-id="element-140" data-mp="3sfm755c3t8eq">
                {sampleTimeline.map(([stage, time]) => <tr key={stage} className="border-b border-brand/10" data-id="element-141" data-mp="34qb5llmxj9zj">
                    <th scope="row" className="py-2.5 pr-3 align-top font-semibold text-brand-deep" data-id="element-142" data-mp="2zrzu76gzkrf7">
                      {stage}
                    </th>
                    <td className="whitespace-nowrap py-2.5 text-right font-bold tabular-nums text-brand" data-id="element-143" data-mp="13obxpapbrh8k">{time}</td>
                  </tr>)}
                <tr data-id="element-144" data-mp="1de4x7dc705wg">
                  <th scope="row" className="py-3 pr-3 text-xs font-black uppercase tracking-wider text-brand-deep" data-id="element-145" data-mp="1dfprr2yiboub">
                    Total
                  </th>
                  <td className="whitespace-nowrap py-3 text-right font-black tabular-nums text-brand-deep" data-id="element-146" data-mp="kq938ge0cs3d">30 min</td>
                </tr>
              </tbody>
            </table>
            <p className="pb-4 text-xs italic leading-relaxed text-slate-600" data-id="element-147" data-mp="pqx4rvzv4rbu">
              Illustrative example. Exercises, dosage, timing, and progression must be adapted to each patient's
              clinical assessment and response.
            </p>
          </div>
          <div className="border-t border-brand/10 bg-slate-50 px-5 py-4" data-id="element-148" data-mp="255b184v1anr0">
            <p className="text-[11px] font-black uppercase tracking-wider text-brand-deep" data-id="element-149" data-mp="2a44ebw6escqn">Every exercise includes:</p>
            <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-150" data-mp="2k7jaxxspy11n">
              {protocolStructure.map(item => <li key={item} className="rounded-md border border-brand/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-700" data-id="element-151" data-mp="2faax29elsj67">
                  {item}
                </li>)}
            </ul>
          </div>
        </article>
      </div>
    </section>;
}